import {HANDLE_DARK_PREFERENCE, LOAD_PREFERENCES} from "../actions/types";

export const initialState = {
	_dark: false,
	_author: "Ahmed Karim",
	_email: "ahmed.karim64@outlook.fr",
	_tel: "0767165032",
	_year_old: 1999,
	_network: {
		facebook: "https://www.facebook.com/karim.pedro.3760/",
		twitter: "https://twitter.com/pedrokarim64",
		stackoverflow: "https://stackoverflow.com/users/12248607/pedrokarim64",
		github: "https://github.com/pedrokarim"
	},
	_address: {
		country: "France",
		state: "Brest, 29200",
		address: "Brest 29200"
	}
};

export default function(state = initialState, action) {
	switch (action.type) {
		case LOAD_PREFERENCES:
			return {
				...state,
				...action.payload
			};
		case HANDLE_DARK_PREFERENCE:
			let newState = {
				...state,
				_dark: typeof action.payload === 'boolean' ? action.payload : !state._dark
			};
			localStorage._preference = JSON.stringify(newState);
			return newState;
		default:
			return state;
	}
}
